import React from "react";

const directors = [
  {
    name: "Jasmine Cooper",
    title: "MANAGING DIRECTOR",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    description: [
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention.",
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention."
    ],
    color: "#f9b233"
  },
  {
    name: "Kendra Williams",
    title: "SENIOR DESIGNER",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    description: [
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention.",
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention."
    ],
    color: "#f9b233"
  },
  {
    name: "Natasha James",
    title: "WEBSITE DEVELOPER",
    image: "https://randomuser.me/api/portraits/women/68.jpg",
    description: [
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention.",
      "This slide is 100% editable. Adapt it to your needs and capture your audience's attention."
    ],
    color: "#f9b233"
  }
];

const directorStyles = `
  .director-main {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #000;
  }
  .director-header {
    background: #144552;
    color: #fff;
    padding: 32px 0 16px 48px;
    font-size: 32px;
    font-weight: 500;
    letter-spacing: -0.5px;
  }
  .director-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 0 0 0;
    position: relative;
    min-height: 600px;
    background: #144552;
    border-radius: 24px;
    box-shadow: 0 4px 32px 0 rgba(20,69,82,0.15);
  }
  }
  .director-bar {
    width: 80px;
    min-width: 80px;
    background: #144552;
    border-radius: 0 40px 40px 0;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
  .director-list {
    flex: 1;
    margin-left: 80px;
    display: flex;
    flex-direction: column;
    gap: 44px;
    z-index: 2;
    width: 100%;
  }
  .director-row {
    display: flex;
    align-items: center;
    gap: 32px;
    position: relative;
    min-height: 140px;
    background: #000;
    border-radius: 12px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);
    padding: 32px 32px 32px 72px;
    margin-bottom: 0;
    transition: flex-direction 0.3s, padding 0.3s;
  }
  .director-img {
    min-width: 150px;
    min-height: 150px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    border: 6px solid #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.10);
    overflow: hidden;
    background: #fff;
    position: absolute;
    left: -75px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: width 0.3s, height 0.3s, left 0.3s;
  }
  .director-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .director-info {
    margin-left: 80px;
    flex: 1;
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: margin-left 0.3s;
  }
  .director-name {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 2px;
    color: #fff;
  }
  .director-title {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 8px;
    color: #f9b233;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .director-desc {
    margin: 0;
    padding-left: 20px;
    color: #fff;
  }
  .director-desc li {
    font-size: 15px;
    color: #fff;
    margin-bottom: 2px;
    font-weight: 400;
  }
  @media (max-width: 900px) {
    .director-content {
      flex-direction: column;
      padding-left: 0;
      min-height: unset;
    }
    .director-bar {
      display: none;
    }
    .director-list {
      margin-left: 0;
      gap: 32px;
    }
    .director-row {
      flex-direction: row;
      padding-left: 56px;
      min-height: 120px;
    }
    .director-img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-bottom: 0;
      width: 90px;
      height: 90px;
      min-width: 90px;
      min-height: 90px;
    }
    .director-info {
      margin-left: 70px;
    }
  }
  @media (max-width: 600px) {
    .director-header {
      font-size: 18px;
      padding-left: 8px;
      padding-top: 18px;
      padding-bottom: 8px;
    }
    .director-content {
      padding: 16px 0 0 0;
    }
    .director-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding: 18px 8px 18px 8px;
      min-height: unset;
    }
    .director-img {
      position: static;
      left: unset;
      top: unset;
      transform: none;
      margin-bottom: 8px;
      width: 70px;
      height: 70px;
      min-width: 70px;
      min-height: 70px;
      margin-left: 0;
      margin-right: 0;
    }
    .director-info {
      margin-left: 0;
      width: 100%;
      align-items: flex-start;
    }
    .director-name {
      font-size: 17px;
    }
    .director-title {
      font-size: 13px;
    }
    .director-desc li {
      font-size: 13px;
    }
  }
`;

const Director = () => (
  <div className="director-main" style={{ marginTop: "90px" }}>
    <style>{directorStyles}</style>
    <div className="director-header">
      Website Landing Page Design Proposal - Our Team (1/2)
    </div>
    <div className="director-content">
      <div className="director-bar"></div>
      <div className="director-list">
        {directors.map((d, idx) => (
          <div key={d.name} className="director-row">
            <div className="director-img">
              <img src={d.image} alt={d.name} />
            </div>
            <div className="director-info">
              <div className="director-name">{d.name}</div>
              <div className="director-title" style={{ color: d.color }}>{d.title}</div>
              <ul className="director-desc">
                {d.description.map((desc, i) => (
                  <li key={i}>{desc}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Director;
